import { baseApi } from './baseApi';

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardCounts: builder.query({
      query: () => ({
        url: 'dashboard/counts',
        method: 'GET',
      }),
      providesTags: ['Dashboard'],
      transformResponse: (response) => response,
    }),
  }),
});

export const { useGetDashboardCountsQuery } = dashboardApi;

